import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-lot-add-photo-uploading-list-item-preview-overlay',
  templateUrl: './lot-add-photo-uploading-list-item-preview-overlay.component.html',
  styleUrls: ['./lot-add-photo-uploading-list-item-preview-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotAddPhotoUploadingListItemPreviewOverlayComponent {
  @Input()
  @HostBinding('class.is-auction-list')
  isAuctionList = false;

  @Output() remove = new EventEmitter<void>();
  @Output() openPreview = new EventEmitter<void>();
  @Output() setAsAuctionList = new EventEmitter<void>();
}
